module.exports = function(bootstrap) {

    "use strict";
    bootstrap.directive('detailsSidebar', function(){
        return {
            replace: true,
            scope: {
                details: "=",
                ready: "=",
                perObject:"=?",
                coreMetricsConfig: "="   //for coremetrics
            },
            template: require('articles/providers/detailsSidebar/detailsSidebar.html'),
            controller: ['$scope', '$state', 'coremetrics', 'sessionData', 'parseProviderDetails',
                function($scope, $state, coremetrics, sessionData, parseProviderDetails) {

                    function initialize(){

                        var details = $scope.details || $state.params.details || {};

                        $scope.enablePCP = sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                            sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PCP'] &&
                            sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PCP'].booleanValue;
                        $scope.enablePER = sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                            sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PER'] &&
                            sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PER'].booleanValue;

                        $scope.showPostPasswordPCP =  sessionData && sessionData.loggedIn && $state.current.name !== 'providers.por';

                        if (sessionData.basicInfo && sessionData.basicInfo.role &&~["ba", "bacancelled", "agent", "agency_admin"].indexOf(sessionData.basicInfo.role.toLowerCase())){
                            $scope.suppressPER = true;
                        }
                        if($scope.details.type === 'Doctor'){
                            $scope.details.type = 'D';
                        }
                        else if($scope.details.type === 'Vendor'){
                            $scope.details.type = 'G';
                        }
                        else if($scope.details.type === 'Facility'){
                            $scope.details.type = 'F';
                        }

                        $scope.features = parseProviderDetails.filterFeatures(details.selectedLocation.features);
                        $scope.isProfessional = (details.professionalInfo.displayName) ? true : false;
                        $scope.specialtiesList = (details.selectedLocation && details.selectedLocation.specialties) ? true : false;

                        $scope.formattedName = details.professionalInfo.displayName || details.selectedLocation.displayName;
                        // $scope.specialties = (details.selectedLocation && details.selectedLocation.specialties) ? details.selectedLocation.specialties.join(', ') : '';
                        $scope.specialties = (details.selectedLocation && details.selectedLocation.specialties.length <= 5) ? details.selectedLocation.specialties.join(', ')  : "Multi-Specialty";
                        $scope.isEligibleAsPCP = ($scope.features && $scope.features.pcpEligible && $scope.features.pcpEligible === 'TRUE') || false;
                        $scope.productId = $state.params.productId;
                        $scope.providerId = details.selectedLocation && details.selectedLocation.fivePartKey && details.selectedLocation.fivePartKey.providerId;
                        $scope.isMyPcp = $scope.details.myPCP;
                        $scope.returnUrl = $state.params.returnUrl || null;
                        $scope.fromPage = $state.params.fromPage || null;

                        $scope.pcpIndex = $state.params.pcpIndex;
                        $scope.isTypePcp = function () {
                            if ($state.params.pcp === 'true') {
                                return true;
                            } else if ($state.params.pcp === 'false') {
                                return false;
                            } else if(sessionData && sessionData.loggedIn){
                                if(sessionData.lobs){

                                    if(sessionData.lobs.hasOwnProperty('PPO') || sessionData.lobs.hasOwnProperty('EPO')){
                                        return false;
                                    } else {
                                        return true;
                                    }
                                }
                            }
                            else {
                                return null;
                            }

                        }();
                        $scope.currentMemberPcpInfo = details.currentMemberPcpInfo || {};

                        $scope.isBlacklisted = !!($state.current.name === 'providers.reviewDisclaimer' || $state.current.name === 'providers.newReview');

                        if (!$scope.reviews || !$scope.reviews.length) {
                            $scope.ratingMessage = 'Not rated';
                        }

                    }

                    initialize();

                    $scope.goToDisclaimer = function () {

                        var details = $scope.details;

                        if(details.reviewObj && details.reviewObj.rating !== null){
                            //TODO: This is how the review information is being passed over. seems ghetto and probably needs cleaned up.
                            $scope.reviews = details.reviewObj.reviews;
                            $scope.overallReviews = details.reviewObj.overallReviews;
                            $scope.rating = details.reviewObj.rating;
                            $scope.reviewCount = details.reviewObj.reviewCount;
                            $scope.ratingMessage = details.reviewObj.ratingMessage;
                        }

                        if ($scope.isProfessional) {
                            coremetrics.elementTag($scope.coreMetricsConfig.categoryId + ':PROVIDERS:PHYSICIAN WRITE A REVIEW', $scope.coreMetricsConfig.categoryId + ':PROVIDERS');
                        } else {
                            coremetrics.elementTag($scope.coreMetricsConfig.categoryId + ':PROVIDERS:FACILITIES WRITE A REVIEW', $scope.coreMetricsConfig.categoryId + ':PROVIDERS');
                        }

                        $state.go('providers.reviewDisclaimer', {
                            displayName: $scope.formattedName,
                            practitionerId: $state.params.practitionerId,
                            vendorId : $state.params.vendorId,
                            vendorType: $state.params.vendorType,
                            locationSequenceNumber: $state.params.locationSequenceNumber,
                            productId: $state.params.productId
                        });
                    };

                    $scope.goToReviews = function () {
                        $state.go('providers.allReviews', {
                            displayName: $scope.formattedName,
                            practitionerId: $state.params.practitionerId,
                            vendorId : $state.params.vendorId,
                            vendorType: $state.params.vendorType,
                            locationSequenceNumber: $state.params.locationSequenceNumber,
                            productId: $state.params.productId
                        });
                    };

                }]
        };
    });
};